import { styled } from '@mui/material';

export const Iframe = styled('iframe')(() => ({
  width: '90%',
  height: 600,
  scrollbarWidth: 'thin',
  scrollbarColor: 'black transparent',
}));
